// @flow

import DOM from '../../util/dom';
import {extend, bindAll} from '../../util/util';
import Popup from '../popup';
import {ClickControlBase} from './click_control_base';
import {MapMouseEvent, MapTouchEvent} from '../events';
import type {Options} from './click_control_base';
import type Map from '../map';

/**
 * The `WeatherAlertClickControl` adds the ability to show a popup when a weather alert is clicked on.
 *
 * @implements {IControl}
 *
 * @example
 * const weatherAlertClickControl = TrimbleMaps.WeatherAlertClickControl();
 * map.addControl(weatherAlertClickControl);
 */
class WeatherAlertClickControl extends ClickControlBase {
    _certainty: string;
    _severity: string;
    _urgency: string;
    _eventName: string;

    constructor(options?: Options) {
        const opt = extend({layerId: 'weatheralert-weatheralert_fill'}, options);
        super(opt);
        bindAll([
            '_onNameFilter'
        ], this);
    }

    onAdd(map: Map) {
        map.on('weatheralert.eventname', this._onNameFilter);
        return super.onAdd(map);
    }

    onRemove() {
        this._map.off('weatheralert.eventname', this._onNameFilter);
        return super.onRemove();
    }

    _onClick(event: MapMouseEvent | MapTouchEvent) {
        this._certainty = '';
        this._severity = '';
        this._urgency = '';
        this._eventName = '';
        // $FlowFixMe
        const features = event.features;
        if (features && features.length > 0) {
            const popupContentContainer = DOM.create('div', 'trimblemaps-ctrl-wapopup');
            const properties = features[features.length - 1].properties;
            popupContentContainer.innerHTML = `<strong><a href="${properties.eventId}" target="_blank">${properties.title}</a></strong> <br /> ${properties.summary}`;
            this._popup = new Popup({})
                .setLngLat(event.lngLat)
                .setDOMContent(popupContentContainer);
            if (this._options.showPopup) {
                this._popup.addTo(this._map);
            }
            this._certainty = properties.certainty;
            this._severity = properties.severity;
            this._urgency = properties.urgency;
            this._eventName = properties.eventName;
            this._clickControlEventHandler();
        }
    }

    _onContentFilter(e: Object) {
        const certainty = e.data.find(item => { return item.id === 'certainty'; });
        const severity = e.data.find(item => { return item.id === 'severity'; });
        const urgency = e.data.find(item => { return item.id === 'urgency'; });
        if (e.id === 'weatheralerts') {
            if ((certainty.value !== 'All' && certainty.value !== this._certainty) ||
                (severity.value !== 'All' && severity.value !== this._severity) ||
                (urgency.value !== 'All' && urgency.value !== this._urgency)) {
                if (this._popup && this._popup.isOpen()) this._popup.remove();
            }
        }
    }

    _onNameFilter(e: Object) {
        if (e.id === 'weatheralertslegend') {
            if (e.data.indexOf(this._eventName) === -1) {
                if (this._popup && this._popup.isOpen()) this._popup.remove();
            }
        }
    }
}

export default WeatherAlertClickControl;
